module.exports = __webpack_public_path__ + "static/img/white-logo.8379be5c.png";